import * as React from "react";
import {Link} from "react-router-dom";
import {DirectDebitDetailsSection} from "./DirectDebitDetailsSection";

interface IProps {
    policyNumber: string,
    interaction: any;
    haveActiveMandate: boolean
    mandate: any;
    annualToMonthly?: boolean;
}

interface IState {
    mandate: any;
}

export class DirectDebitSection extends React.Component<IProps, IState> {


    constructor(props: any) {
        super(props);

        this.state = {
            mandate: this.props.mandate
        }
    }

    public render(): JSX.Element {
        const {mandate} = this.state;
        const {haveActiveMandate} = this.props;
        const directDebitProcessLink = `/dashboard/${this.props.policyNumber}/paymentDetails/editDirectDebit/`;
        return (
            <div className="text-center mt-4 payment-details-section icon-direct-debit-before margin-top-0">
                {this.props.annualToMonthly &&
                    <div className="bubble-container">
                        <div className="corner-bubble">Renewal only</div>
                    </div>
                }
                <div className="dashboard-panel-title my-3">Direct Debit details</div>
                <DirectDebitDetailsSection haveActiveMandate={haveActiveMandate} mandate={mandate}/>
                <div className="px-3 my-4 grid-col-2">
                    <Link
                        to={{
                            pathname: directDebitProcessLink,
                            state: {policyNumber: this.props.policyNumber}
                        }}
                        className="btn btn-white-dashboard m-auto"
                        id="editDirectDebit">
                        {haveActiveMandate ? 'Edit Direct Debit' : 'Set-up Direct Debit'}
                    </Link>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/annual/DirectDebitSection.tsx